












































































































































import {Component, Prop} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {PickingListDeliveryStore} from "@/modules/pickinglistdeliveries/store";
import {Lading} from "@/interfaces/entity";
import {PickingListDeliveryType} from '@/enums/type';
import {LadingStatus} from "@/enums/status";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import {deleteBillLadingOfPickingList} from "@/modules/pickinglistdeliveries/services";

@Component({
    name: "PLDeliveryPrint",
    components: {LadingStatusLabel},
})
export default class extends mixins(CommonMixin) {
    @Prop({required: true, type: Number}) readonly id!: number;
    @Prop({type: Boolean, default: false}) readonly isPrint!: boolean;
    PickingListDeliveryType = PickingListDeliveryType;
    LadingStatus = LadingStatus;

    get billLadings() {
        const billLadings = this.getProp(this.pickingListDelivery, 'billLadings', []) as any;
        return billLadings.map((billLading: Lading, index) => ({...billLading, stt: index + 1}));
    }

    get pickingListDelivery() {
        return PickingListDeliveryStore.data[this.id];
    }

    async deleteBillLading(billLadingRowGuid: string) {
        try {
            if (this.billLadings.length < 2) {
                this.$message.error('Bảng kê chỉ có 1 vận đơn, vui lòng hủy bảng kê');
                return;
            }
            await deleteBillLadingOfPickingList({billLadingRowGuid, pickingListDeliveryId: this.id});
            const billLadings = PickingListDeliveryStore.data[this.id]?.billLadings;
            billLadings.splice(billLadings.findIndex((billLading: Lading) => billLading.rowGuid === billLadingRowGuid), 1);
            this.$message.success("Xóa vận đơn thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || 'Xóa vận đơn thất bại');
        }
    }

    canDeleteBillLading(billLading: Lading): boolean {
        if (this.pickingListDelivery.type === PickingListDeliveryType.Employee && billLading.status === LadingStatus.PhanCongPhat)
            return true;
        else if (this.pickingListDelivery.type === PickingListDeliveryType.Partner && billLading.status !== LadingStatus.PhatThanhCong)
            return true;
        else
            return false;
    }
}
